import React, { Component } from "react";
import { View, Image, TouchableOpacity } from "react-native";
import unSelectedStarImage from "../../assets/images/unSelectedRatingStar.png";
import selectedStarImage from "../../assets/images/selectedRatingStar.png";
import styles from "../styles/customRatingStyle";
const ratingArray = ["star1", "star2", "star3", "star4", "star5"];
class CustomInfoTip extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hoveredIndex: -1,
    };
  }

  onMouseLeave = (index) => {
    this.setState({
      hoveredIndex: -1,
    });
  };

  onMouseEnter = (index) => {
    this.setState({
      hoveredIndex: index,
    });
  };

  onPressRatingStar = (index) => {
    this.props.updateSentMessage(index + 1);
  };

  renderRatingStars = () => {
    const { hoveredIndex } = this.state;
    return (
      <View style={styles.starView}>
        {ratingArray.map((itm, index) => {
          return (
            <TouchableOpacity
              disableOptions={this.props.disableOptions}
              style={this.props.disableOptions ? styles.disabledOpacity : null}
              key={`rating${index}`}
              nativeID={`rating${index}`}
              onPress={() => this.onPressRatingStar(index)}
              onMouseLeave={() => this.onMouseLeave(index)}
              onMouseEnter={() => this.onMouseEnter(index)}
            >
              <Image
                style={styles.starImage}
                source={
                  index <= hoveredIndex
                    ? selectedStarImage
                    : unSelectedStarImage
                }
              />
            </TouchableOpacity>
          );
        })}
      </View>
    );
  };

  render() {
    return <View style={styles.Maincontainer}>{this.renderRatingStars()}</View>;
  }
}

export default CustomInfoTip;
